import { Instance } from 'mobx-state-tree';
import { ShopifyOrderImportSummaryDtoModelBase } from './ShopifyOrderImportSummaryDtoModel.base';

/* The TypeScript type of an instance of ShopifyOrderImportSummaryDtoModel */
export interface ShopifyOrderImportSummaryDtoModelType extends Instance<typeof ShopifyOrderImportSummaryDtoModel.Type> {}

/* A graphql query fragment builders for ShopifyOrderImportSummaryDtoModel */
export { selectFromShopifyOrderImportSummaryDto, shopifyOrderImportSummaryDtoModelPrimitives, ShopifyOrderImportSummaryDtoModelSelector } from './ShopifyOrderImportSummaryDtoModel.base';

/**
 * ShopifyOrderImportSummaryDtoModel
 */
export const ShopifyOrderImportSummaryDtoModel = ShopifyOrderImportSummaryDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
